import { Tabs } from 'flowbite';
const currentUrl = window.location.href;
if (currentUrl.includes('surpass')) {
  // options with default values
  const tabElements = [
    {
      id: 'nominees-tab',
      triggerEl: document.querySelector('#nominees-tab'),
      targetEl: document.querySelector('#nominees'),
    },
    {
      id: 'winners-tab',
      triggerEl: document.querySelector('#winners-tab'),
      targetEl: document.querySelector('#winners'),
    },
  ];
  // options with default values
  const options = {
    activeClasses: 'my-tab-item-active',
    inactiveClasses: 'my-tab-item',
    onShow: () => {},
  };
  const tabs = new Tabs(tabElements, options);
  currentUrl.includes('winners')
    ? tabs.show('winners-tab')
    : tabs.show('nominees-tab');
}

if (currentUrl.includes('contact')) {
  // options with default values
  const tabElements = [
    {
      id: 'business-tab',
      triggerEl: document.querySelector('#business-tab'),
      targetEl: document.querySelector('#business'),
    },
    {
      id: 'discover-tab',
      triggerEl: document.querySelector('#discover-tab'),
      targetEl: document.querySelector('#discover'),
    },
  ];
  // options with default values
  const options = {
    activeClasses: 'my-contact-tab-item-active',
    inactiveClasses: 'my-contact-tab-item',
    onShow: () => {},
  };
  const tabs = new Tabs(tabElements, options);
  tabs.getActiveTab('discover-tab');
}
